module.exports = __webpack_public_path__ + "static/media/motion-sensor-9-axis.014f95d7.svg";